import React, { useState, useEffect, useRef } from "react";
import { Image } from "../Image";

export const ResponsiveImage = (props) => {
    const { src } = props;
    const imageEl = useRef();
    const mounted = useRef();
    const [imageUrl, setImageUrl] = useState(null);

    useEffect(() => {
        mounted.current = true;
        const match = src?.match(/(http.*\/.*)\/(.*)/);

        if (!src || !match || match?.length < 3) {
            return setImageUrl(src);
        }

        const hostName = match[1];
        const fileName = match[2];

        if (!mounted.current || !imageEl || !imageEl.current) {
            return;
        }

        const frameSizes = imageEl.current.getBoundingClientRect();
        const width = Math.round(frameSizes.width);
        const height = Math.round(frameSizes.height);

        let resizePath;

        // Resize by width
        if (width >= height) {
            if (frameSizes.width <= 150) {
                resizePath = `resized/150x0`;
            } else if (frameSizes.width <= 450) {
                resizePath = `resized/450x0`;
            } else if (frameSizes.width <= 750) {
                resizePath = `resized/750x0`;
            } else {
                resizePath = "resized/1500x0";
            }
        }

        // Resize by height
        else {
            if (frameSizes.height <= 150) {
                resizePath = `resized/0x150`;
            } else if (frameSizes.height <= 450) {
                resizePath = `resized/0x450`;
            } else if (frameSizes.height <= 750) {
                resizePath = "resized/0x750";
            } else {
                resizePath = "resized/0x1500";
            }
        }

        setImageUrl(`${hostName}/${resizePath}/${fileName}`);

        return () => {
            mounted.current = false;
        };
    }, [src]);

    return <Image {...props} elementRef={imageEl} src={imageUrl} />;
};
